import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DownloadExcelComponent } from 'src/app/module/shared/components/download-excel/download-excel.component';
import { ViewEditCommonComponent } from 'src/app/module/shared/components/view-edit-common/view-edit-common.component';
import { AccessControlService } from 'src/app/shared/services/AccessControl.service';
import { TabService } from 'src/app/shared/tab.service';
import { AddordersComponent } from '../add-orders/add-orders.component';
import { CommonBulkPrintComponent } from 'src/app/module/shared/components/common-bulk-print/common-bulk-print.component';
import { CommonCsvComponent } from 'src/app/module/shared/components/common-csv/common-csv.component';
import { Observable } from 'rxjs';
import { ordersService } from '../../services/orders.service';
import { NeAddOrderComponent } from '../ne-add-order/ne-add-order.component';
import { AddComponentComponent } from '../add-component/add-component.component';
import { RemoveComponentComponent } from '../remove-component/remove-component.component';
import { ExchangeComponentComponent } from '../exchange-component/exchange-component.component';
import * as moment from 'moment';
import { swapComponentComponent } from '../swap-component/swap-component.component';
import { TyrePositionComponentDrag } from '../tyre-position/tyre-position.component';
import { TyrePositionDragDropComponent } from '../tyre-position-drag-drop/tyre-position-drag-drop.component';
import { SharedService } from 'src/app/shared/shared.service';
import { masterServices } from 'src/app/module/master/services/ems-services.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css'],
})
export class ordersComponent {
  theme = 'dark';
  pageSize = 15; // Number of items per page
  pageIndex = 0;
  currentPage: number = 0;
  pageNumber = 0;
  sortingCol: string = 'id';
  direction: string = 'DESC';
  tableName = 'orderTable';
  warehouseFilter: any = [];
  warehouseData: any = [];
  getWarehouseList: any;
  customerModel: any;
  selectedWarehouse: any;
  storedWarehouse: any;
  clientId: any;
  clientDetails: any;
  ref: DynamicDialogRef | undefined;
  selectedData: any[] = [];
  editContation: boolean = false;
  // filters= [];
  filters: { key: string; value: any }[] = [];
  userType: any;
  columns = [
    {
      showColumn: true,
      sortingColumn: '',
      key: 'truckNumber',
      header: 'Truck Number',
      sortable: false,
      viewDialog: true,
      type: 'text',
    },
    {
      showColumn: true,
      sortingColumn: '',
      key: 'truckModel',
      header: 'Truck Model',
      sortable: false,
      type: 'text',
      viewDialog: false,
    },

    {
      showColumn: true,
      sortingColumn: '',
      key: 'truckBrand',
      header: 'Truck Brand',
      sortable: false,
      type: 'text',
    },
    {
      showColumn: true,
      sortingColumn: '',
      key: 'associatedTyres',
      header: 'Horse TYRES',
      sortable: false,
      type: 'text',
    },
    {
      showColumn: true,
      sortingColumn: '',
      key: 'associatedTrailerTyres',
      header: 'Trailer TYRES',
      sortable: false,
      type: 'text',
    },
    {
      showColumn: true,
      sortingColumn: '',
      key: 'associatedBatteries',
      header: 'Battery',
      sortable: false,
      type: 'text',
    },
    {
      showColumn: true,
      sortingColumn: '',
      key: 'puc',
      header: 'PUC',
      sortable: false,
      type: 'text',
    },
    {
      showColumn: true,
      sortingColumn: '',
      key: 'status',
      header: 'Status',
      sortable: false,
      viewDialog: false,
      type: 'status',
    },
    {
      showColumn: true,
      sortingColumn: '',
      key: 'insuranceNumber',
      header: 'Insurance Number',
      sortable: false,
      type: 'text',
    },
    {
      showColumn: true,
      sortingColumn: '',
      key: 'vendorName',
      header: 'vendor',
      sortable: false,
      type: 'text',
    },
 
    {
      showColumn: true,
      sortingColumn: 'createdAt',
      key: 'createdAt',
      header: 'Created At',
      sortable: true,
      type: 'date',
    },
    {
      showColumn: true,
      sortingColumn: 'updatedAt',
      key: 'updatedAt',
      header: 'Updated At',
      sortable: true,
      type: 'date',
    },
  ];

  columnsToExport: string[] = [
    'financialYearId',
    'budgetDate',
    'budgetType',
    'reference',
    'accountName',
    'warehouseName',
    'approvedBudget',
    'expense',
    'createdAt',
    'createdByName',
    'updatedAt',
    'updatedByName',
    'budgetProof',
    'remarks',
  ];

  dropdownOptions: { [key: number]: string[] } = {
    0: ['2023-2024', '2022-2023'],
    1: ['January', 'February', 'March'],
  };

  warehouseList = []; // Define warehouse list here
  accounts = []; // Define account list here
  totalCount: any;
  @ViewChild(DownloadExcelComponent) downloadExcel!: DownloadExcelComponent;
  @ViewChild(CommonBulkPrintComponent) printData!: CommonBulkPrintComponent;
  @ViewChild(CommonCsvComponent) downloadCsv!: CommonCsvComponent;

  selectedRows: any[] = [];
  tableLists: any = [];
  user_details: any;
  dashboardLedger: any;
  totalTruck: any;
  liveTruck: any;
  draftTruck: any;
  parkedTruck: any;
  complianceAlert: any;
  selectedCard: string = 'live';
  odometerReadingShow: boolean = false;


selectedTyre: any[] = [];
pollutionVendorList: any;
selectedFiles:FileList  | null = null;
currentFile?: File;
progress = 0;
@ViewChild('odometerReadingInput') odometerReadingInput!: ElementRef;
odometerReadingUrl: string | null = null;
initialKmTravelled:any
  selectedFleet: any;

  constructor(
    private ordersService: ordersService,
    private primengConfig: PrimeNGConfig,
    private fb: FormBuilder,
    private tabService: TabService,
    public dialogService: DialogService,
    private messageService: MessageService,
    private router: Router,
    public accessControlService: AccessControlService,
    public sharedService: SharedService,
    private masterServices: masterServices,
     private cd: ChangeDetectorRef
  ) {
    this.getWarehouseList = JSON.parse(localStorage.getItem('wareHouseList')!);
    this.accounts = JSON.parse(localStorage.getItem('accountList')!);
    this.user_details = JSON.parse(localStorage.getItem('UserDetails')!);
    this.userType = this.user_details?.userType;
    this.primengConfig.ripple = true;
  }

  searchForm = this.fb.group({
    WAREHOUSE_ID_IN: new FormControl(''),
    ACCOUNT_ID_IN: new FormControl(''),
    // FC_NAME: new FormControl(''),
    STATUS: new FormControl(null),
  });

  ngOnInit(): void {
    this.getdashboardLedger();
    setTimeout(() => {
      this.truckFilter('live');
    }, 1000);
  }

  getdashboardLedger() {
    this.ordersService.dashboardLedger().subscribe((res: any) => {
      this.dashboardLedger = res?.responseObject;
      let data = res.responseObject;

      this.totalTruck =
        data.find((x: any) => x.name === 'Total Truck')?.count || 0;
      this.liveTruck =
        data.find((x: any) => x.name === 'Live Truck')?.count || 0;
      this.draftTruck =
        data.find((x: any) => x.name === 'Draft Truck')?.count || 0;
      this.complianceAlert =
        data.find((x: any) => x.name === 'Compliance Alert')?.count || 0;
      this.parkedTruck =   data.find((x: any) => x.name === 'Parked Truck')?.count || 0;
      // this.totalCount = res?.responseObject?.totalElements;
    });
  }

 truckFilter(type: string) {
  //   if (!this.dashboardLedger || !Array.isArray(this.dashboardLedger)) {
  //   return;
  // }
  this.selectedCard = type;

  const nameMap: any = {
    tottal: 'Total Truck',
    live: 'Live Truck',
    drafts: 'Draft Truck',
    parked: 'Parked Truck',
    compliance: 'Compliance Alert',
  };

  const selected = this.dashboardLedger.find(
    (x: any) => x.name === nameMap[type]
  );

  let filters: any[] = [];

  // 🔹 Helper: get truckIds by name
  const getTruckIds = (name: string) => {
    return (
      this.dashboardLedger.find((x: any) => x.name === name)?.truckIds || ''
    );
  };

  // 🔹 Helper: push filter safely
  const addFilter = (key: string, value: string) => {
    if (value && value.trim() !== '') {
      filters.push({ key, value });
    }
  };

  // 🔥 Type  logic
  switch (type) {
    case 'live': {
      const combinedIds = [getTruckIds('Live Truck'), getTruckIds('Parked Truck')]
        .filter(Boolean)
        .join(',');

      addFilter('TRUCK_BUILD_ID_IN', combinedIds);
      addFilter('STATUS_IN', 'Running,Parked');
      break;
    }

    case 'drafts': {
      addFilter('TRUCK_BUILD_ID_IN', getTruckIds('Draft Truck'));
      addFilter('STATUS_IN', 'Draft');
      break;
    }

    case 'parked': {
      addFilter('TRUCK_BUILD_ID_IN', getTruckIds('Parked Truck'));
      addFilter('STATUS_IN', 'Parked');
      break;
    }

    case 'tottal':
    case 'compliance':
    default: {
      addFilter('TRUCK_BUILD_ID_IN', selected?.truckIds || '');
      break;
    }
  }

  this.filters = filters;

  // 🔹 Compliance edge case
  if (selected?.name === 'Compliance Alert' && selected?.count === 0) {
    this.tableLists = [];
    return;
  }

  this.getList();

}
  reloadEvent(event: any) {
    console.log(event);
    // this.getList()
  }

  getList() {
    let postData: any[] = [];
    let vendorIds: string[] = [];
    let accountIds: any;
    this.filters = [...(this.filters || []), ...postData];
    this.filters = this.filters.filter(
      (item: any) =>
        (item.value && item.value.toString().trim() !== '') ||
        (item.dateValue && item.dateValue.toString().trim() !== ''),
    );
    this.tableLists = [];
    this.ordersService
      .getTruckBuild(
        this.filters,
        this.pageNumber,
        this.pageSize,
        this.sortingCol,
        this.direction,
      )
      .subscribe(
        (data: any) => {
          if (data) {
            this.tableLists = data?.responseObject?.content;
            this.totalCount = data?.responseObject?.totalElements;
            this.selectedData = [];
          }
        },
        (err) => {
          this.totalCount = 0;
          this.tableLists = [];
        },
      );
  }

  getListExportApi = (params: any): Observable<any> => {
    const {
      filters = {},
      pageNumber = 0,
      pageSize = 250,
      sortingCol = 'id',
      direction = 'DESC',
    } = params;

    return this.ordersService.getTruckBuild(
      filters,
      pageNumber,
      pageSize,
      sortingCol,
      direction,
    );
  };

  onFilterChange(event: any) {
    if (event) {
      // console.log(event);
      this.filters = event;
      if(this.filters.length > 0){
        this.getList();
      }
    }
  }

  onResetFilters() {
    this.filters = [];
    this.truckFilter(this.selectedCard)
    // this.getList();
  }

  paginate(event: any) {
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getList();
  }

  onSortChange(event: { columnKey: string; sortOrder: 'ASC' | 'DESC' }): void {
    this.sortingCol = event.columnKey;
    this.direction = event.sortOrder;
    this.getList();
  }

  onSelectedRowsChange(selectedRows: any[]) {
    const storedData = JSON.parse(
      localStorage.getItem('columnToExport') || '{}',
    );

    this.columnsToExport = storedData['budget'] ?? this.columnsToExport;

    this.selectedRows = selectedRows;
    this.selectedData = selectedRows;

    if (this.downloadExcel) {
      this.downloadExcel.data = [...selectedRows];
    } else {
      console.error('DownloadExcelComponent is not initialized.');
    }
  }

  addBudget(type: any) {
    console.log(type,'ppppppppp')
    // this.ref = this.dialogService.open(AddordersComponent, {
    this.ref = this.dialogService.open(NeAddOrderComponent, {
      // header: `${type} Order`,
      header: type == 'Edit' ? 'Edit':'Assemble Truck',
      data:
        type == 'Edit' ? {
            editData: this.selectedRows,
            edit: this.editContation
        }
        : {
            editData: this.selectedData,
            edit: this.editContation,
          },
      width: '90vw',
      contentStyle: { overflow: 'auto', position: 'top' },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log('resss', data);
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data?.responseMessage,
        });
      }
      this.getList();
    });
  }

  receiveDataEvent(data: any[]) {
    console.log(data);
    this.selectedData = data;
  }
  editEvent() {
    this.editContation = true;
    // console.log(this.editContation);
    // this.addBudget('Edit');
    // console.log(this.selectedRows[0])
    this.editTruck(this.selectedRows[0] , false)
  }
  deleteEvent() {
    // const ids = Array.from(new Set(this.selectedData.map((item: any) => item.id))).join(',');
    // this.masterServices.deleteExpense(ids).subscribe((data: any) => {
    //   if(data){
    //     this.selectedData = [];
    //     this.getList();
    //     this.messageService.add({
    //       severity: 'success',
    //       summary: 'Success',
    //       detail: 'Expense Deleted successfully',
    //     });
    //   }
    //  },err => {
    //   this.tableLists = []
    //  });
  }

  duplicateEvent() {
    // console.log(this.selectedData);
    const payload = {
      expenseCategoryId: this.selectedData[0].expenseCategoryId,
      expenseModeId: this.selectedData[0].expenseModeId,
      expenseName: this.selectedData[0].expenseName,
      status: this.selectedData[0].status,
    };
    //  this.masterServices.expenseAddOrUpdate(payload).subscribe((data: any) => {
    //   if(data){
    //    this.messageService.add({
    //      severity: 'success',
    //      summary: 'Success',
    //      detail: 'Expense added successfully',
    //    });
    //    this.getList();
    //    this.selectedData = [];
    //   }
    //  });
  }

  // upload(url: any, params: any) {
  //   this.tabService.addTab({
  //     label: 'Upload',
  //     path: url,
  //     fullPath: '',
  //     filterData: [],
  //     // pageNumber: 0,
  //     // pageSize: 10
  //   });
  //   this.router.navigate([url], { queryParams: params });
  // }

  openDetail(id: any) {
    this.tabService.addTab({
      label: 'Truck Mapping',
      path: `/truck-mapping/truck-details/${id}`,
      fullPath: '',
      filterData: [],
      // pageNumber: 0,
      // pageSize: 10
    });
    this.router.navigate(['/truck-mapping/truck-details/' + id]);
  }

  sortData(key: string) {
    // this.sortingCol, this.direction
    if (this.sortingCol === key) {
      this.direction = this.direction === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortingCol = key;
      this.direction = 'ASC';
    }
    this.getList();
  }
  onRowSelect(row: any) {
    if (row) {
      this.selectedRows = [];
      this.selectedRows.push(row);
    }
    if (row.selected) {
      this.selectedRows = this.tableLists.filter((r: any) => r.selected);
    } else {
      this.selectedRows = this.selectedRows.filter((r) => r !== row);
    }
    console.log(this.selectedRows);

    // this.isAllSelected = this.data.every(r => r.selected);
    // this.selectedRowsChange.emit(this.selectedRows);
  }

  addComponentPopUp() {
    this.ref = this.dialogService.open(AddComponentComponent, {
      // header: `${type} Order`,
      header: `Add Component`,
      data: {
        data: this.selectedRows[0],
        // edit: this.editContation
      },
      width: '50vw',
      contentStyle: { overflow: 'auto', position: 'top' },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log('resss', data);
      if (data) {
        // this.messageService.add({
        //   severity: 'success',
        //   summary: 'Success',
        //   detail: data?.responseMessage,
        // });
      }
      this.getList();
      this.getdashboardLedger();
      this.selectedRows = [];
    });
  }

  swapComponentPopUp(){
    this.ref = this.dialogService.open(swapComponentComponent, {
      // header: `${type} Order`,
      header: `Swap Component`,
      data: {
        data: this.selectedRows[0],
        // edit: this.editContation
      },
      width: '65vw',
      contentStyle: { overflow: 'auto', position: 'top' },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log('resss', data);
      if (data) {
        // this.messageService.add({
        //   severity: 'success',
        //   summary: 'Success',
        //   detail: data?.responseMessage,
        // });
      }
      this.getList();
      this.getdashboardLedger();
      this.selectedRows = [];
    });
  }

  removeComponentPopUp() {
    this.ref = this.dialogService.open(RemoveComponentComponent, {
      header: `Remove Component`,
      data: {
        data: this.selectedRows[0],
      },
      width: '55vw',
      contentStyle: { overflow: 'auto', position: 'top' },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log('resss', data);
      if (data) {
        // this.messageService.add({
        //   severity: 'success',
        //   summary: 'Success',
        //   detail: data?.responseMessage,
        // });
      }
      this.getList();
      this.getdashboardLedger();
      this.selectedRows = [];
    });
  }



  
editTruck(item:any, position:any){
 // this.ref = this.dialogService.open(AddordersComponent, {
    this.ref = this.dialogService.open(NeAddOrderComponent, {
      // header: `${type} Order`,
      header: `Edit Assemble Truck`,
      data: {
        editData: item,
        edit: true,
        tyrePosition: position
      },
      width: '90vw',
      contentStyle: { overflow: 'auto', position: "top" },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log("resss", data)
      this.selectedRows=[]
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data?.responseMessage,
        });
      }
      this.getList()
      this.getdashboardLedger();
    });
}

exchangeComponentPopUp() {
  this.ref = this.dialogService.open(ExchangeComponentComponent, {
    // header: `${type} Order`,
    header: `Exchange Component`,
    data: {
      data: this.selectedRows[0],
      // edit: this.editContation
    },
    width: '50vw',
    contentStyle: { overflow: 'auto', position: 'top' },
    draggable: true,
    styleClass: 'no-close-icon-dialog',
  });
  this.ref.onClose.subscribe((data: any) => {
    console.log('resss', data);
    if (data) {
      // this.messageService.add({
      //   severity: 'success',
      //   summary: 'Success',
      //   detail: data?.responseMessage,
      // });
    }
    this.getList();
    this.selectedRows = [];
  });
}



ViewHistory(selectedItem:any): void {
  console.log(selectedItem)
  // if (!selectedItem || !this.selectedComponent) return;
  // this.tabService.addTab({
  //   label: 'Life Cycle Tracker', path: `/life-cycle-tracking/life-cycle-tracking-detail/${this.serialNumber}`,
  //   fullPath: '',
  //   filterData: [],
  // });
  this.router.navigate([`/life-cycle-tracking/life-cycle-tracking-detail/${selectedItem?.truckNumber}`], {
    queryParams: { 
      id: selectedItem?.id,
      type: "Truck"
    }
  });
}


getValidityClass(date: string): string {
  if (!date) return '';
  const insuranceDate = moment(date, "DD-MM-YYYY").startOf('day');
  const currentDate = moment().startOf('day');
  const diffDays = insuranceDate.diff(currentDate, 'days');
  if (diffDays <= 30 && diffDays >= 0) {
    return 'cd-warn';  
  } else if (diffDays < 0) {
    return 'cd-expired';
  }

  return '';
}

positionCheck(){
this.ref = this.dialogService.open(TyrePositionComponentDrag, {
    // header: `${type} Order`,
    header: `Position Component`,
    data: {
      data: this.selectedRows[0],
      // edit: this.editContation
    },
    width: '60vw',
    contentStyle: { overflow: 'auto', position: 'top' },
    draggable: true,
    styleClass: 'no-close-icon-dialog',
  });
}
positionCheckDrag(){
this.ref = this.dialogService.open(TyrePositionDragDropComponent, {
    // header: `${type} Order`,
    header: `Position Component`,
    data: {
      data: this.selectedRows[0],
      // edit: this.editContation
    },
    width: '75vw',
    contentStyle: { overflow: 'auto', position: 'top' },
    draggable: true,
    styleClass: 'no-close-icon-dialog',
  });
}

updateOdometer(item:any){
  console.log(item)
  this.selectedFleet = item
  this.odometerReadingShow = true
}
closeOdometerPopup(){

  this.odometerReadingShow = false
}
updateOdometerData(){
  const payload = {
    id : this.selectedFleet?.id,
    initialKmTravelled:this.initialKmTravelled,
    odometerReadingUrl: this.odometerReadingUrl
  }
  this.ordersService.getBuild(payload).subscribe((data: any) => {
      if (data) {
        this.odometerReadingShow = false
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data?.responseMessage,
        });
        this.getList()
        this.odometerReadingUrl = ''
        this.initialKmTravelled = ''
        this.odometerReadingInput.nativeElement.value = null;

      }
    });
}

selectFile(event: any , type:any): void {
    this.selectedFiles = event.target.files;
    const fileType = type
      const file = event.target.files[0];
     const allowedTypes = [
      'application/pdf',
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/svg+xml'
    ];
    if (!allowedTypes.includes(file.type)) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Uploaded file must be in excel format.',
      });
      return;
    }
    this.upload(fileType)
  }
   upload(type: any): void {
      if (this.selectedFiles) {
          const file: File | null = this.selectedFiles.item(0);
        if (file) {
          this.currentFile = file;
          this.masterServices.upload(
            this.currentFile,
          ).subscribe({
            next: (event: any) => {
              if (event.type === HttpEventType.UploadProgress) {
                this.progress = Math.round((100 * event.loaded) / event.total);
                if (this.progress == 100) {
                  this.progress = 99;
                }
              } else if (event instanceof HttpResponse) {
                  this.odometerReadingUrl = event.body.responseObject
                  this.cd.detectChanges();
                setTimeout(() => {
                }, 2000);
              }
            },
            error: (err: any) => {
              if (err.error && err.error.message) {
                const message = err.error.message;
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: err.error.message,
                });
              } else {
                const message = 'Could not upload the file!';
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: message,
                });
              }
            },
          });
        }
      }
    }

 removeFile(type:any){
    this.odometerReadingUrl = null
  if (this.odometerReadingInput) {
    this.odometerReadingInput.nativeElement.value = null;
  }
}    

}